import { Autocomplete, TextField } from "@mui/material";
import useApi from "_api/index";
import { useCarBrands } from "contexts/CarBrandsContext";
import { useEffect, useMemo, useState } from "react";

const OptionCarBrands = ({ value, onChangeValue, ...props }) => {
  const { carBrands } = useCarBrands();

  const selectedBrand = useMemo(() => {
    if (!value) return null;

    if (typeof value === "object" && value.id) {
      return carBrands.find((brand) => brand.id === value.id) || null;
    }

    if (typeof value === "number") {
      return carBrands.find((brand) => brand.id === value) || null;
    }

    if (typeof value === "string") {
      return carBrands.find((brand) => brand.name === value) || null;
    }

    return null;
  }, [carBrands, value]);

  return (
    <Autocomplete
      {...props}
      fullWidth
      options={carBrands}
      getOptionLabel={(option) => option.name || ""}
      value={selectedBrand}
      onChange={(event, newValue) => {
        console.log("Selected brand:", newValue);
        if (onChangeValue) {
          onChangeValue(newValue ? newValue.id : null);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          placeholder="เลือกยี่ห้อรถ"
          sx={{
            "& .MuiOutlinedInput-root": {
              bgcolor: "white",
              height: "40px",
            },
          }}
          error={props.error || false}
          helperText={props.helperText || ""}
        />
      )}
      sx={{ width: "100%" }}
    />
  );
};

export default OptionCarBrands;
